<template>
  <div class="wrap">
  </div>
</template>

<script>
export default {
  // name: "order",
  data(){
    return {
    }
  },
  methods: {
    onSubmit(){

    }
  }
}
</script>
<style scoped>
.wrap {
    padding: 20px;
    width: 100%;
    height: 100%;
    background-color:#fff;
    box-sizing: border-box;
}
.place {
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.division{
    padding:0 5px;
    color: #C0C4CC;
}
.link{
    text-decoration:none;
    color: #303133
}
.active{
   color: #909399; 
}
</style>